import { IconName } from "@fortawesome/fontawesome-svg-core";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import WButton from "../wbutton/WButton";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { motion } from "framer-motion";
import { Dispatch, useState } from "react";
import { useTranslation } from "react-i18next";
import { faCheck, faXmark } from "@fortawesome/pro-regular-svg-icons";

/* eslint-disable-next-line */
export interface LPriceBoxProps {
  tableTopTitle?: string | undefined | null;
  tableTopTitleColor?: string | undefined | null;
  tableMainTitle?: string | undefined | null;
  tableMainTitleColor?: string | undefined | null;
  tableDescription?: string | undefined | null; //rich text
  monthylRegularPrice?: string | undefined | null;
  monthlyDiscountedPrice?: string | undefined | null;
  monthlyUnderPriceText?: string | undefined | null; //rich text
  yearlyRegularPrice?: string | undefined | null;
  yearlyDiscountedPrice?: string | undefined | null;
  yearlyUnderPriceText?: string | undefined | null; //rich text
  highlightTag?: string | undefined | null;
  tableButton?: {
    text?: string | undefined | null;
    url?: string | undefined | null;
  };
  priceBenefits?: {
    text?: string | undefined | null;
    icon?: IconName | undefined | null;
    isGryedOut?: boolean | undefined | null;
    isBold?: boolean | undefined | null;
    isIndented?: boolean | undefined | null;
  }[];
  showYearly?: boolean | undefined | null;
  activeTab?: string;
  setActiveTab?: Dispatch<string>;
}

export function LPriceBox(props: LPriceBoxProps) {
  const router = useRouter();

  const { t: tCommon } = useTranslation("common");

  const maxLength = props?.priceBenefits?.length;
  const [sliceNr, setSliceNr] = useState(10);

  return (
    <div
      className={clsx([
        props?.highlightTag &&
          "border-2 border-ekgreen relative overflow-hidden",
        "w-full p-4 bg-white shadow-lg rounded-3xl hover:scale-[1.02] transition-all hover:shadow-2xl hover:-translate-y-3 h-full",
      ])}
    >
      {/* {props?.highlightTag && (
        <div className="absolute left-0 py-1 -ml-6 text-xs text-center text-white -rotate-45 w-28 top-5 bg-ekgreen">
          {props?.highlightTag}
        </div>
      )} */}

      <motion.div
        className="flex flex-col w-full text-center"
        initial={{ opacity: 0, y: -15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", delay: 0.2 }}
      >
        {props?.highlightTag && (
          <div className="flex items-center justify-center gap-3 mb-3">
            <div
              className={clsx([
                "font-bold",
                props?.activeTab === "MONTH" && "text-ekgreen",
              ])}
            >
              LUNAR
            </div>
            <div className="flex flex-col items-center gap-1">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  checked={props?.activeTab === "ANNUAL"}
                  onClick={() => {
                    props?.setActiveTab &&
                      props?.setActiveTab(
                        props?.activeTab === "MONTH" ? "ANNUAL" : "MONTH"
                      );
                  }}
                />
                <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-focus:ring-4 peer-focus:ring-transparent peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-ekgreen" />
              </label>
            </div>
            <div
              className={clsx([
                "font-bold",
                props?.activeTab === "ANNUAL" && "text-ekgreen",
              ])}
            >
              ANUAL (salvezi 38%)
            </div>
          </div>
        )}
        {props?.tableTopTitle && props?.tableTopTitle !== "SIMPLE" && (
          <span
            className="font-semibold h-6"
            style={{ color: props?.tableTopTitleColor || "" }}
          >
            {props?.tableTopTitle}
          </span>
        )}
        {props?.tableMainTitle && (
          <span
            className={`text-2xl font-extrabold line-clamp-2 min-h-[4rem] flex items-center justify-center ${
              props?.tableMainTitleColor ? "" : "text-ekgreen"
            }`}
            style={{ color: props?.tableMainTitleColor || "" }}
          >
            {props?.tableMainTitle}
          </span>
        )}
      </motion.div>
      {props?.tableDescription && (
        <div className="mt-8 text-center small-markdown min-h-[3rem] line-clamp-2">
          <ReactMarkdown>{props?.tableDescription}</ReactMarkdown>
        </div>
      )}
      <div className="flex flex-col items-center justify-center  mt-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", delay: 0.5 }}
          className="line-clamp-1"
        >
          {props?.monthlyDiscountedPrice && !props?.showYearly && (
            <div className="text-xl font-bold line-through -mt-7 text-ekgray">
              {props?.monthylRegularPrice}
            </div>
          )}
          {props?.monthylRegularPrice && !props?.showYearly && (
            <div className="text-3xl font-bold">
              {props?.monthlyDiscountedPrice ?? props?.monthylRegularPrice}
            </div>
          )}
          {props?.monthlyUnderPriceText && !props?.showYearly && (
            <div className="mt-2 text-sm">{props?.monthlyUnderPriceText}</div>
          )}

          {props?.yearlyDiscountedPrice && props?.showYearly && (
            <div className="text-xl font-bold line-through -mt-7 text-ekgray">
              {props?.yearlyRegularPrice}
            </div>
          )}
          {props?.yearlyRegularPrice && props?.showYearly && (
            <div className="text-4xl font-bold">
              {props?.yearlyDiscountedPrice ?? props?.yearlyRegularPrice}
            </div>
          )}
          {props?.yearlyUnderPriceText && props?.showYearly && (
            <div className="mt-2 text-sm">{props?.yearlyUnderPriceText}</div>
          )}
        </motion.div>
        {props?.tableButton?.url && props?.tableButton?.text && (
          <WButton
            type={props?.highlightTag ? "primary-red-btn" : "decline"}
            text={props?.tableButton?.text}
            onClick={() => router.push(props?.tableButton?.url ?? "")}
            className="w-full mt-10"
          />
        )}
        {props?.priceBenefits?.length && props?.priceBenefits?.length > 0 && (
          <div className="flex flex-col w-full gap-3 mt-10">
            {props?.priceBenefits
              ?.slice(0, props?.highlightTag ? sliceNr : -1)
              ?.map((benefit, index) => (
                <div
                  key={index}
                  className={clsx([
                    "flex items-center w-full gap-2 text-left",
                    benefit?.isIndented && "pl-5",
                  ])}
                >
                  {benefit?.icon === "check" && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className={clsx([
                        benefit?.isGryedOut ? "text-ekgray" : "text-ekgreen",
                        benefit?.isBold && "font-bold",
                        "w-5 h-5",
                      ])}
                    />
                  )}

                  <span
                    className={clsx([
                      benefit?.isGryedOut ? "text-ekgray" : "text-ekblue",
                      benefit?.isBold && "font-bold",
                    ])}
                  >
                    {benefit?.text}
                  </span>
                </div>
              ))}
            {maxLength && sliceNr < maxLength && props?.highlightTag && (
              <div
                onClick={() => {
                  setSliceNr((prevState) => prevState + 10);
                }}
                className="font-bold cursor-pointer text-ekgreen"
              >
                {tCommon("see-more-benefits")}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default LPriceBox;
